module.exports = __webpack_public_path__ + "img/tequila-slammer.d0b02732.jpg";